module.exports = __webpack_public_path__ + "static/media/growth 1.859b642c.png";